import { defineComponent as _defineComponent } from 'vue'
import { tailwindSurfaceFontClass } from '@@/bits/font'
import { useSurfaceStore } from '@@/pinia/surface'
import { useSurfacePermissionsStore } from '@@/pinia/surface_permissions'
import { useSurfaceSettingsStore } from '@@/pinia/surface_settings'
import SurfaceBuilder from '@@/vuecomponents/SurfaceBuilder.vue'
import SurfaceTitleDescription from '@@/vuecomponents/SurfaceTitleDescription.vue'
import ProcessedImage from '@@/vuecomponents/processed_image.vue'
import { storeToRefs } from 'pinia'
import { computed, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfaceTitle',
  emits: ['title-changed', 'description-changed', 'portrait-changed'],
  setup(__props, { emit }) {

const surfaceStore = useSurfaceStore()
const { title, description, portrait, backgroundLuminance, colorScheme, fontId, isMap, isEmbedded } =
  storeToRefs(surfaceStore)

const surfacePermissionsStore = useSurfacePermissionsStore()
const { canIAdminister } = storeToRefs(surfacePermissionsStore)

const surfaceSettingsStore = useSurfaceSettingsStore()
const { showSettingsPanel } = surfaceSettingsStore

const PORTRAIT_SIZE = 48



const fontClass = computed<string>(() => {
  return tailwindSurfaceFontClass(fontId.value)
})

watch(title, (): void => {
  emit('title-changed')
})

watch(description, (): void => {
  emit('description-changed')
})

watch(portrait, (): void => {
  emit('portrait-changed')
})

const tryModify = (): void => {
  if (!isEmbedded.value && canIAdminister.value) {
    showSettingsPanel()
  }
}

return { __sfc: true,surfaceStore, title, description, portrait, backgroundLuminance, colorScheme, fontId, isMap, isEmbedded, surfacePermissionsStore, canIAdminister, surfaceSettingsStore, showSettingsPanel, PORTRAIT_SIZE, emit, fontClass, tryModify, SurfaceBuilder, SurfaceTitleDescription, ProcessedImage }
}

})